import React from 'react';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { AppserviceSkuDialog } from '../../../Common/Dialog/AppserviceSkuDialog';

const useStyles = makeStyles()((theme: Theme) => ({
  menu: {
    padding: 0,
  },
  button: {
    margin: theme.spacing(1),
  },
}));

export default function AppservicePlanDialog(
  props: Readonly<{
    addItemToState: (item: string[]) => void;
  }>,
) {
  const { classes } = useStyles();
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState('Not Selected');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value: string) => {
    setOpen(false);
    if ('Not Selected' !== value) {
      setSelectedValue(value);
      const appserviceplan: string[] = [];
      appserviceplan.push(value);
      props.addItemToState(appserviceplan);
    }
  };

  return (
    <div>
      <br />
      <Button
        variant="contained"
        onClick={handleClickOpen}
        className={classes.button}
        startIcon={<AddCircleIcon />}
      >
        New AppService
      </Button>
      <AppserviceSkuDialog
        selectedValue={selectedValue}
        open={open}
        onClose={handleClose}
      />
    </div>
  );
}
